import { useTranslation } from "react-i18next";
import "./styles.scss";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { useState } from "react";
import { useGeneralContext } from "../../pages/General/Context";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as DashboardIcon } from "../../layout/left_menu_icons/dashboard.svg";
import { ReactComponent as CalculatorIcon } from "../../layout/left_menu_icons/calculator.svg";
import { ReactComponent as ConversationIcon } from "../../layout/left_menu_icons/conversation.svg";
import { ReactComponent as DownloadIcon } from "../../layout/left_menu_icons/import.svg";
import { ReactComponent as NewuserIcon } from "../../layout/left_menu_icons/newUser.svg";
import { ReactComponent as PaperIcon } from "../../layout/left_menu_icons/paper.svg";
import { ReactComponent as PersonIcon } from "../../layout/left_menu_icons/person.svg";
import { ReactComponent as SearchPlusIcon } from "../../layout/left_menu_icons/searchPlus.svg";
import { ReactComponent as DealIcon } from "../../layout/left_menu_icons/deal.svg";
import { ReactComponent as AskInterview } from "../../layout/left_menu_icons/ask_interview.svg";
import { ReactComponent as FolderSearch } from "../../layout/left_menu_icons/folder_search.svg";
import { ReactComponent as SearchMobility } from "../../layout/left_menu_icons/search_icon.svg";

const Sidebar = () => {
  const { t } = useTranslation();
  const [hide, setHide] = useState(true);
  const { userInformation } = useGeneralContext();
  const route = useLocation();

  return (
    <div className="sidebar-container">
      <ProSidebar
        onMouseOver={() => {
          setHide(false);
        }}
        onMouseLeave={() => {
          setHide(true);
        }}
        collapsed={hide}
      >
        <Menu>
          <div>
            {hide === true ? (
              <div style={{ visibility: "hidden" }}>{t("Overview")}</div>
            ) : (
              <div className="subtitle-sidebar-overview">{t("Overview")}</div>
            )}
            <MenuItem
              icon={<DashboardIcon width="20px" height="20px" />}
              className={
                route.pathname === "/dashboard" || route.pathname === "/"
                  ? "background-submenu"
                  : "submenu-select"
              }
            >
              <p>{t("Dashboard")}</p>
              <Link to="/dashboard" />{" "}
            </MenuItem>
            {userInformation.permissions?.Reports_View && (
              <MenuItem
                icon={<PaperIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/reports"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Reports")}</p>
                <Link to="/reports" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.Reports_View_All && (
              <MenuItem
                icon={<PaperIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/reports/Global"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Global Reports ")}</p>
                <Link to="/reports/Global" />{" "}
              </MenuItem>
            )}
          </div>

          <div>
            <div className={`subtitle-sidebar${hide ? "-collapsed" : ""}`}>
              {t("Recruitment")}
            </div>

            {userInformation.permissions?.List_View_PreCand && (
              <MenuItem
                icon={<PersonIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/precandidate"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Pre-Candidates")}</p>
                <Link to="/precandidate" />{" "}
              </MenuItem>
            )}

            <MenuItem
              icon={<PersonIcon width="20px" height="20px" />}
              className={
                route.pathname === "/interviews/docslist"
                  ? "background-submenu"
                  : "submenu-select"
              }
            >
              <p>{t("DocOnline")}</p>
              <Link to="/interviews/docslist" />{" "}
            </MenuItem>

            {userInformation.permissions?.International_Mobility && (
              <MenuItem
                icon={<SearchMobility width="20px" height="20px" />}
                className={
                  route.pathname === "/global/candidates"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("International Mobility Research")}</p>
                <Link to="/global/candidates" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.Import_PreCand && (
              <MenuItem
                icon={<DownloadIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/precandidate/import"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Import Cvs")}</p>
                <Link to="/precandidate/import" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.List_View_Reapplications && (
              <MenuItem
                icon={<AskInterview width="20px" height="20px" />}
                className={
                  route.pathname === "/interview/reapplications"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Re-Applications")}</p>
                <Link to="/interview/reapplications" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.List_View_Interview && (
              <MenuItem
                icon={<ConversationIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/interview" ||
                  route.pathname.includes("/interview/view/") ||
                  route.pathname.includes("/interview/10/1")
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Interviews")}</p>
                <Link to="/interview" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.Create_Edit_Interview && (
              <MenuItem
                icon={<NewuserIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/interview/createoredit" ||
                  route.pathname.includes("/interview/createOrEdit/")
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("New Interview")}</p>
                <Link to="/interview/createoredit" />{" "}
              </MenuItem>
            )}
            {userInformation.permissions?.Use_Advanced_Search && (
              <MenuItem
                icon={<SearchPlusIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/interview/advanceSearch"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Advanced Search")}</p>
                <Link to="/interview/advanceSearch" />{" "}
              </MenuItem>
            )}

            {userInformation.permissions?.Use_File_Search && (
              <MenuItem
                icon={<FolderSearch width="20px" height="20px" />}
                className={
                  route.pathname === "/fileContentSearch"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("File Content Search")}</p>
                <Link to="/fileContentSearch" />{" "}
              </MenuItem>
            )}

            <MenuItem
              icon={<SearchPlusIcon width="20px" height="20px" />}
              className={
                route.pathname === "/intelligent-search"
                  ? "background-submenu"
                  : "submenu-select"
              }
            >
              <p>{t("intelligent search")}</p>
              <Link to="/intelligent-search" />{" "}
            </MenuItem>

            {userInformation.permissions?.Hired_Candidates_List_Change && (
              <MenuItem
                icon={<DealIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/hiredCandidates" ||
                  route.pathname.includes("/hiredCandidates/10/1")
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Hired Candidates")}</p>
                <Link to="/hiredCandidates" />{" "}
              </MenuItem>
            )}
          </div>
          <div>
            {" "}
            {userInformation?.permissions?.List_View_PreProposal && (
              <>
                <div className={`subtitle-sidebar${hide ? "-collapsed" : ""}`}>
                  {t("Proposals")}
                </div>

                <MenuItem
                  icon={<PaperIcon width="20px" height="20px" />}
                  className={
                    route.pathname === "/preproposals"
                      ? "background-submenu"
                      : "submenu-select"
                  }
                >
                  <p>{t("Proposals")}</p>
                  <Link to="/preproposals" />{" "}
                </MenuItem>
              </>
            )}
            {userInformation?.permissions?.Use_Project_Simulation && (
              <MenuItem
                icon={<CalculatorIcon width="20px" height="20px" />}
                className={
                  route.pathname === "/proposals/projectEstimation"
                    ? "background-submenu"
                    : "submenu-select"
                }
              >
                <p>{t("Project Estimation")}</p>
                <Link to="/proposals/projectEstimation" />{" "}
              </MenuItem>
            )}
          </div>
        </Menu>
      </ProSidebar>
    </div>
  );
};

export default Sidebar;
